// extracted by mini-css-extract-plugin
export var settingsList = "_3q-0";
export var settingsRow = "_3q-1";
export var warningDot = "_3q-2";